import {useMemo} from 'react';

import {useSiteClientData} from '@amblique/king-living/app/hooks/use-site-client-data';
import {DEFAULT_PASSWORD_POLICY, normalizePasswordPolicy} from '@amblique/king-living/app/utils/password-policy';

/**
 * Loads password validation rules from BM site preferences via Custom SCAPI.
 * Falls back to kl-customers defaults when API data is missing.
 *
 * @returns {{policy: typeof DEFAULT_PASSWORD_POLICY, isLoading: boolean}}
 */
export const usePasswordPolicy = () => {
  const {data: response, isLoading} = useSiteClientData();
  const rawPolicy = response?.clientData?.preferences?.passwordConstraints;

  const policy = useMemo(
    () => normalizePasswordPolicy(rawPolicy),
    [rawPolicy]
  );

  return {
    policy,
    isLoading,
  };
};
